import { render, staticRenderFns } from "./myh_tend.vue?vue&type=template&id=b7b1334c&"
import script from "./myh_tend.vue?vue&type=script&lang=js&"
export * from "./myh_tend.vue?vue&type=script&lang=js&"
import style0 from "./myh_tend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports